<div class="sidebar">
	<div class="border-top border-bottom ePM_border_dark app-menu-top">
		<a class="xs-hidden" routerLink="/ang/Company/{{configData.AppConfig.company}}">
			<img class="d-inline mt-3 ml-3" style="max-width: 50px;"
				*ngIf="configData.AppConfig.customLogo"
				[src]="configData.baseUrl + 'api/Company/Logo/' + configData.AppConfig.company + '?c=' + configData.AppConfig.cacheVal" />
		</a>
		<div class="CompanyName xs-hidden" [style.width]="configData.AppConfig.customLogo ? '135px' : '195px'">
			<a routerLink="/ang/Company/{{configData.AppConfig.company}}" title="{{configData.AppConfig.companyName}}">
				{{configData.AppConfig.companyName}}
				<span class="subNameMenu">
					<br />{{subscriptionName}}
				</span>
			</a>
		</div>
	</div>
	<div class="menu">
		<CompanySearch *ngIf="isSuperAdmin" (companyChange)="pickCompany($event)"></CompanySearch>
		<input type="checkbox" id="superuser" *ngIf="isSuperAdmin" />
		<div class="main dropdown-main" *ngIf="isSuperAdmin">
			<label for="superuser">Super User</label>
			<ul class="dropdown-content">
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['Companies'].link">{{configData.MenuPages['Companies'].name}}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Companies')" [class.gold]="hasFavorite('Companies')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['Reports'].link">{{configData.MenuPages['Reports'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Reports')" [class.gold]="hasFavorite('Reports')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeEmployment'].link">{{configData.MenuPages['TypeEmployment'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeEmployment')" [class.gold]="hasFavorite('TypeEmployment')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeSalary'].link">{{configData.MenuPages['TypeSalary'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeSalary')" [class.gold]="hasFavorite('TypeSalary')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeSalaryChange'].link">{{configData.MenuPages['TypeSalaryChange'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeSalaryChange')" [class.gold]="hasFavorite('TypeSalaryChange')"><i class="fa fa-star"></i></button>
				</li>

				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeSourceOfHire'].link">{{configData.MenuPages['TypeSourceOfHire'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeSourceOfHire')" [class.gold]="hasFavorite('TypeSourceOfHire')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeTermination'].link">{{configData.MenuPages['TypeTermination'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeTermination')" [class.gold]="hasFavorite('TypeTermination')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeCompanyDiscount'].link">{{configData.MenuPages['TypeCompanyDiscount'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeCompanyDiscount')" [class.gold]="hasFavorite('TypeCompanyDiscount')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypePaymentSubscription'].link">{{configData.MenuPages['TypePaymentSubscription'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypePaymentSubscription')" [class.gold]="hasFavorite('TypePaymentSubscription')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeSubscriptionCategory'].link">{{configData.MenuPages['TypeSubscriptionCategory'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeSubscriptionCategory')" [class.gold]="hasFavorite('TypeSubscriptionCategory')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['Courses'].link">{{configData.MenuPages['Courses'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Courses')" [class.gold]="hasFavorite('Courses')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['CourseFeedback'].link">{{configData.MenuPages['CourseFeedback'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('CourseFeedback')" [class.gold]="hasFavorite('CourseFeedback')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeCourseCatagory'].link">{{configData.MenuPages['TypeCourseCatagory'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeCourseCatagory')" [class.gold]="hasFavorite('TypeCourseCatagory')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeCourseTag'].link">{{configData.MenuPages['TypeCourseTag'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeCourseTag')" [class.gold]="hasFavorite('TypeCourseTag')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeCountry'].link">{{configData.MenuPages['TypeCountry'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeCountry')" [class.gold]="hasFavorite('TypeCountry')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeGender'].link">{{configData.MenuPages['TypeGender'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeGender')" [class.gold]="hasFavorite('TypeGender')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeMaritalStatus'].link">{{configData.MenuPages['TypeMaritalStatus'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeMaritalStatus')" [class.gold]="hasFavorite('TypeMaritalStatus')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypePhone'].link">{{configData.MenuPages['TypePhone'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypePhone')" [class.gold]="hasFavorite('TypePhone')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TypeTracker'].link">{{configData.MenuPages['TypeTracker'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TypeTracker')" [class.gold]="hasFavorite('TypeTracker')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['Search'].link">{{configData.MenuPages['Search'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Search')" [class.gold]="hasFavorite('Search')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['AppHelpInfo'].link">{{configData.MenuPages['AppHelpInfo'].name }}</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('AppHelpInfo')" [class.gold]="hasFavorite('AppHelpInfo')"><i class="fa fa-star"></i></button>
				</li>
			</ul>
		</div>
		<div class="main" *ngIf="!isMaster">
			<a routerLink="/ang/Dash">Dashboard</a>
			<PageHelp [menuKey]="'HeaderDashboard'" [isMenuDescription]="true"></PageHelp>
		</div>
		<div *ngIf="!isMaster && !isLMS && (isSignUpCompany || isDentalProgram)" class="main inactive">
			<label><a routerLink="/ang/Payment/NoLMS">Courses</a></label>
		</div>
		<input type="checkbox" id="training-program" *ngIf="!isMaster && isLMS && (isSignUpCompany || isDentalProgram)" />
		<div class="main dropdown-main" *ngIf="!isMaster && isLMS && (isSignUpCompany || isDentalProgram)">
			<label for="training-program">
				Courses
				<PageHelp [menuKey]="'HeaderCourses'" [isMenuDescription]="true"></PageHelp>
			</label>
			<ul class="dropdown-content">
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['MyCourses'].link">{{configData.MenuPages['MyCourses'].name }}</a>
					<PageHelp [menuKey]="'MyCourses'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('MyCourses')" [class.gold]="hasFavorite('MyCourses')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item" *ngIf="!isHR">
					<a [routerLink]="configData.MenuPages['People'].link">{{configData.MenuPages['People'].name }}</a>
					<PageHelp [menuKey]="'People'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('People')" [class.gold]="hasFavorite('People')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['CourseLibrary'].link">{{configData.MenuPages['CourseLibrary'].name }}</a>
					<PageHelp [menuKey]="'CourseLibrary'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('CourseLibrary')" [class.gold]="hasFavorite('CourseLibrary')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item" *ngIf="!isHR && !isMaster">
					<a [routerLink]="configData.MenuPages['Company'].link">{{configData.MenuPages['Company'].name }}</a>
					<PageHelp [menuKey]="'Company'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Company')" [class.gold]="hasFavorite('Company')"><i class="fa fa-star"></i></button>
				</li>

			</ul>
		</div>

		<div *ngIf="!isMaster && !isLMS && (isSignUpCompany || isDentalProgram)" class="main inactive">
			<label><a routerLink="/ang/Payment/NoLMS">Webinars</a></label>
		</div>
		<input type="checkbox" id="training-program-webinars" *ngIf="!isMaster && isLMS && (isSignUpCompany || isDentalProgram)" />
		<div class="main dropdown-main" *ngIf="!isMaster && isLMS && (isSignUpCompany || isDentalProgram)">
			<label for="training-program-webinars">
				Webinars
				<PageHelp [menuKey]="'HeaderWebinars'" [isMenuDescription]="true"></PageHelp>
			</label>
			<ul class="dropdown-content">
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['MyWebinars'].link">{{configData.MenuPages['MyWebinars'].name }}</a>
					<PageHelp [menuKey]="'MyWebinars'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('MyWebinars')" [class.gold]="hasFavorite('MyWebinars')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item" *ngIf="!isHR">
					<a [routerLink]="configData.MenuPages['People'].link">{{configData.MenuPages['People'].name }}</a>
					<PageHelp [menuKey]="'People'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('People')" [class.gold]="hasFavorite('People')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item" *ngIf="!isSignUpCompany">
					<a [routerLink]="configData.MenuPages['WebinarLibrary'].link">{{configData.MenuPages['WebinarLibrary'].name }}</a>
					<PageHelp [menuKey]="'WebinarLibrary'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('WebinarLibrary')" [class.gold]="hasFavorite('WebinarLibrary')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item" *ngIf="!isHR && !isMaster">
					<a [routerLink]="configData.MenuPages['Company'].link">{{configData.MenuPages['Company'].name }}</a>
					<PageHelp [menuKey]="'Company'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Company')" [class.gold]="hasFavorite('Company')"><i class="fa fa-star"></i></button>
				</li>

			</ul>
		</div>
		<div *ngIf="!isMaster && !isHR && !isSignUpCompany" class="main inactive">
			<label><a routerLink="/ang/Payment/NoHR">HR Toolbox</a></label>
		</div>
		<input *ngIf="(isHR || isMaster) && !isSignUpCompany" type="checkbox" id="hrtoolbox" [(ngModel)]="hrtoolbox" />
		<div *ngIf="(isHR || isMaster) && !isSignUpCompany" class="main dropdown-main">
			<label for="hrtoolbox">
				HR Toolbox
				<PageHelp [menuKey]="'HeaderHRToolbox'" [isMenuDescription]="true"></PageHelp>
			</label>
			<ul class="dropdown-content">
				<li class="dropdown-menu-item" *ngIf="!isMaster">
					<a [routerLink]="configData.MenuPages['Calendar'].link">{{configData.MenuPages['Calendar'].name }}</a>
					<PageHelp [menuKey]="'Calendar'" [isMenuDescription]="true"></PageHelp>
				</li>
				
				<li class="dropdown-menu-item" *ngIf="!isMaster">
					<input type="checkbox" id="tasks" [(ngModel)]="tasks" />
					<div class="sub dropdown-sub">
						<label for="tasks">Tasks
							<PageHelp [menuKey]="'HeaderTasks'" [isMenuDescription]="true"></PageHelp>
						</label>
						<ul class="dropdown-sub-content">
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['MyIncompleteTasks'].link">{{configData.MenuPages['MyIncompleteTasks'].name }}</a>
								<PageHelp [menuKey]="'MyIncompleteTasks'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('MyIncompleteTasks')" [class.gold]="hasFavorite('MyIncompleteTasks')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item">
								<a (click)="editTask()">{{configData.MenuPages['AddTask'].name }}</a>
								<PageHelp [menuKey]="'AddTask'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('AddTask')" [class.gold]="hasFavorite('AddTask')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['TaskHistory'].link">{{configData.MenuPages['TaskHistory'].name }}</a>
								<PageHelp [menuKey]="'TaskHistory'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TaskHistory')" [class.gold]="hasFavorite('TaskHistory')"><i class="fa fa-star"></i></button>
							</li>
						</ul>
					</div>
				</li>
				
				<li class="dropdown-menu-item" *ngIf="!isIntro  && isDentalProgram">
					<input type="checkbox" id="checklists" [(ngModel)]="checklists" />
					<div class="sub dropdown-sub">
						<label for="checklists">
							Training Plans
							<PageHelp [menuKey]="'HeaderChecklists'" [isMenuDescription]="true"></PageHelp>
						</label>
						<ul class="dropdown-sub-content">
							<li class="dropdown-sub-item" *ngIf="!isMaster">
								<a [routerLink]="configData.MenuPages['MyChecklists'].link">{{configData.MenuPages['MyChecklists'].name }}</a>
								<PageHelp [menuKey]="'MyChecklists'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('MyChecklists')" [class.gold]="hasFavorite('MyChecklists')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="!isMaster">
								<a [routerLink]="configData.MenuPages['Checklists'].link">{{configData.MenuPages['Checklists'].name }}</a>
								<PageHelp [menuKey]="'Checklists'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Checklists')" [class.gold]="hasFavorite('Checklists')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isMaster || isAdmin">
								<a [routerLink]="configData.MenuPages['MasterChecklists'].link" [queryParams]="configData.MenuPages['MasterChecklists'].paramMap">{{configData.MenuPages['MasterChecklists'].name }}</a>
								<PageHelp [menuKey]="'MasterChecklists'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('MasterChecklists')" [class.gold]="hasFavorite('MasterChecklists')"><i class="fa fa-star"></i></button>
							</li>
						</ul>
					</div>
				</li>
				
				<li class="dropdown-menu-item" *ngIf="!isMaster">
					<input type="checkbox" id="commendation" [(ngModel)]="commendation" />
					<div class="sub dropdown-sub">
						<label for="commendation">
							Feedback
							<PageHelp [menuKey]="'HeaderFeedback'" [isMenuDescription]="true"></PageHelp>
						</label>
						<ul class="dropdown-sub-content">
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['NewCommendation'].link">{{configData.MenuPages['NewCommendation'].name }}</a>
								<PageHelp [menuKey]="'NewCommendation'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('NewCommendation')" [class.gold]="hasFavorite('NewCommendation')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['Commendations'].link">{{configData.MenuPages['Commendations'].name }}</a>
								<PageHelp [menuKey]="'Commendations'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Commendations')" [class.gold]="hasFavorite('Commendations')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isAdmin">
								<a [routerLink]="configData.MenuPages['CommendationsToApprove'].link">{{configData.MenuPages['CommendationsToApprove'].name }}</a>
								<PageHelp [menuKey]="'CommendationsToApprove'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('CommendationsToApprove')" [class.gold]="hasFavorite('CommendationsToApprove')"><i class="fa fa-star"></i></button>
							</li>
						</ul>
					</div>
				</li>
				
				<li class="dropdown-menu-item">
					<input type="checkbox" id="organization" [(ngModel)]="organization" />
					<div class="sub dropdown-sub">
						<label for="organization">
							Organization
							<PageHelp [menuKey]="'HeaderOrganization'" [isMenuDescription]="true"></PageHelp>
						</label>
						<ul class="dropdown-sub-content">
							<li class="dropdown-sub-item" *ngIf="!isMaster">
								<a [routerLink]="configData.MenuPages['OrgChart'].link">{{configData.MenuPages['OrgChart'].name }}</a>
								<PageHelp [menuKey]="'OrgChart'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('OrgChart')" [class.gold]="hasFavorite('OrgChart')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isAdmin || isMaster">
								<a [routerLink]="configData.MenuPages['People'].link">{{configData.MenuPages['People'].name }}</a>
								<PageHelp [menuKey]="'People'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('People')" [class.gold]="hasFavorite('People')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isAdmin || isMaster">
								<a [routerLink]="configData.MenuPages['JobDesignations'].link">{{configData.MenuPages['JobDesignations'].name }}</a>
								<PageHelp [menuKey]="'JobDesignations'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('JobDesignations')" [class.gold]="hasFavorite('JobDesignations')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isAdmin || isMaster">
								<a [routerLink]="configData.MenuPages['Departments'].link">{{configData.MenuPages['Departments'].name }}</a>
								<PageHelp [menuKey]="'Departments'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Departments')" [class.gold]="hasFavorite('Departments')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isAdmin && !isMaster && !isIntro">
								<a [routerLink]="configData.MenuPages['Offices'].link">{{configData.MenuPages['Offices'].name }}</a>
								<PageHelp [menuKey]="'Offices'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Offices')" [class.gold]="hasFavorite('Offices')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isAdmin && !isMaster">
								<a [routerLink]="configData.MenuPages['Company'].link">{{configData.MenuPages['Company'].name }}</a>
								<PageHelp [menuKey]="'Company'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Company')" [class.gold]="hasFavorite('Company')"><i class="fa fa-star"></i></button>
							</li>
						</ul>
					</div>
				</li>
				
				<li class="dropdown-menu-item">
					<input type="checkbox" id="documents" [(ngModel)]="documents" />
					<div class="sub dropdown-sub">
						<label for="documents">
							{{ isIntro ? 'Templates' : 'Documents' }}
							<PageHelp [menuKey]="'HeaderDocuments'" [isMenuDescription]="true"></PageHelp>
						</label>
						<ul class="dropdown-sub-content">
							<li class="dropdown-sub-item" *ngIf="!isMaster">
								<a [routerLink]="configData.MenuPages['MyDocuments'].link">{{configData.MenuPages['MyDocuments'].name }}</a>
								<PageHelp [menuKey]="'MyDocuments'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('MyDocuments')" [class.gold]="hasFavorite('MyDocuments')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['EmployeeHandbook'].link">{{configData.MenuPages['EmployeeHandbook'].name }}</a>
								<PageHelp [menuKey]="'EmployeeHandbook'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('EmployeeHandbook')" [class.gold]="hasFavorite('EmployeeHandbook')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['Policies'].link">{{configData.MenuPages['Policies'].name }}</a>
								<PageHelp [menuKey]="'Policies'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Policies')" [class.gold]="hasFavorite('Policies')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['JobDescriptions'].link">{{configData.MenuPages['JobDescriptions'].name }}</a>
								<PageHelp [menuKey]="'JobDescriptions'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('JobDescriptions')" [class.gold]="hasFavorite('JobDescriptions')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isDentalProgram">
								<a href="http://epracticemanager.com/documents" target="_blank"> Resources</a>
								<PageHelp [menuKey]="'Resources'" [isMenuDescription]="true"></PageHelp>
							</li>
						</ul>
					</div>
				</li>
				
				<li class="dropdown-menu-item" *ngIf="!isIntro">
					<input type="checkbox" id="performanceReviews" [(ngModel)]="performanceReviews" />
					<div class="sub dropdown-sub">
						<label for="performanceReviews">
							Performance Reviews
							<PageHelp [menuKey]="'HeaderPerformanceReviews'" [isMenuDescription]="true"></PageHelp>
						</label>
						<ul class="dropdown-sub-content">
							<li class="dropdown-sub-item" *ngIf="!isMaster">
								<a [routerLink]="configData.MenuPages['MyPerformanceReviews'].link">{{configData.MenuPages['MyPerformanceReviews'].name }}</a>
								<PageHelp [menuKey]="'MyPerformanceReviews'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('MyPerformanceReviews')" [class.gold]="hasFavorite('MyPerformanceReviews')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="!isMaster">
								<a [routerLink]="configData.MenuPages['ReviewHistory'].link">{{configData.MenuPages['ReviewHistory'].name }}</a>
								<PageHelp [menuKey]="'ReviewHistory'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('ReviewHistory')" [class.gold]="hasFavorite('ReviewHistory')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isMaster || isAdmin">
								<a [routerLink]="configData.MenuPages['PerformanceReviewQuestions'].link">{{configData.MenuPages['PerformanceReviewQuestions'].name }}</a>
								<PageHelp [menuKey]="'PerformanceReviewQuestions'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('PerformanceReviewQuestions')" [class.gold]="hasFavorite('PerformanceReviewQuestions')"><i class="fa fa-star"></i></button>
							</li>
						</ul>
					</div>
				</li>
				
				<li class="dropdown-menu-item" *ngIf="!isMaster && !isIntro">
					<input type="checkbox" id="leaveRequests" [(ngModel)]="leaveRequests" />
					<div class="sub dropdown-sub">
						<label for="leaveRequests">
							Leave Requests
							<PageHelp [menuKey]="'HeaderLeaveRequests'" [isMenuDescription]="true"></PageHelp>
						</label>
						<ul class="dropdown-sub-content">
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['MyLeaveRequests'].link">{{configData.MenuPages['MyLeaveRequests'].name }}</a>
								<PageHelp [menuKey]="'MyLeaveRequests'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('MyLeaveRequests')" [class.gold]="hasFavorite('MyLeaveRequests')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['Entitlements'].link">{{configData.MenuPages['Entitlements'].name }}</a>
								<PageHelp [menuKey]="'Entitlements'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Entitlements')" [class.gold]="hasFavorite('Entitlements')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item">
								<a [routerLink]="configData.MenuPages['RequestsToApprove'].link">{{configData.MenuPages['RequestsToApprove'].name }}</a>
								<PageHelp [menuKey]="'RequestsToApprove'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('RequestsToApprove')" [class.gold]="hasFavorite('RequestsToApprove')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isAdmin">
								<a [routerLink]="configData.MenuPages['PTOTemplates'].link">{{configData.MenuPages['PTOTemplates'].name }}</a>
								<PageHelp [menuKey]="'PTOTemplates'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('PTOTemplates')" [class.gold]="hasFavorite('PTOTemplates')"><i class="fa fa-star"></i></button>
							</li>
							<li class="dropdown-sub-item" *ngIf="isAdmin">
								<a [routerLink]="configData.MenuPages['Holidays'].link">{{configData.MenuPages['Holidays'].name }}</a>
								<PageHelp [menuKey]="'Holidays'" [isMenuDescription]="true"></PageHelp>
								<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('Holidays')" [class.gold]="hasFavorite('Holidays')"><i class="fa fa-star"></i></button>
							</li>
						</ul>
					</div>
				</li>

			</ul>
		</div>
		<div *ngIf="!isTracker && !isSuperAdmin && !isMaster && isAdmin && !isIntro && isDentalProgram" class="main inactive">
			<label><a href="#" onclick="return false;">Diagnostics</a></label>
		</div>
		<input type="checkbox" id="tracker-program" *ngIf="(isTracker || (isSuperAdmin && !isMaster && !isIntro))  && isDentalProgram" />
		<div class="main dropdown-main" *ngIf="(isTracker || (isSuperAdmin && !isMaster && !isIntro))  && isDentalProgram">
			<label for="tracker-program">
				Diagnostics
				<PageHelp [menuKey]="'HeaderDiagnostics'" [isMenuDescription]="true"></PageHelp>
			</label>
			<ul class="dropdown-content">
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TrackerDocs'].link">{{configData.MenuPages['TrackerDocs'].name }}</a>
					<PageHelp [menuKey]="'TrackerDocs'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TrackerDocs')" [class.gold]="hasFavorite('TrackerDocs')"><i class="fa fa-star"></i></button>
				</li>
				<li class="dropdown-menu-item">
					<a [routerLink]="configData.MenuPages['TrackerDocsTools'].link">{{configData.MenuPages['TrackerDocsTools'].name }}</a>
					<PageHelp [menuKey]="'TrackerDocsTools'" [isMenuDescription]="true"></PageHelp>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="addFavorite('TrackerDocsTools')" [class.gold]="hasFavorite('TrackerDocsTools')"><i class="fa fa-star"></i></button>
				</li>
			</ul>
		</div>

		<input type="checkbox" checked="checked" id="favtoolbox" />
		<div class="main dropdown-main">
			<label for="favtoolbox">
				<i class="fa fa-star" style="color: gold;"></i>
				Favorites
			</label>
			<ul class="dropdown-content">
				<li class="dropdown-menu-item" *ngFor="let fav of configData.AppConfig.FavoritePages">
					<a [routerLink]="configData.MenuPages[fav].link ? configData.MenuPages[fav].link : null"
					   [queryParams]="configData.MenuPages[fav].paramMap"
					   (click)="configData.MenuPages[fav].function ? editTask() : null">
						{{configData.MenuPages[fav].name }}
					</a>
					<button type="button" class="btn m-0 p-0 pull-right mr-2" (click)="removeFavorite(fav)"><i class="fa fa-minus-circle"></i></button>
				</li>
			</ul>
		</div>
	</div>
</div>